// src/reducers/noteReducer.js

import { sortNotes } from "../utils/filters"
import {
        ADD_NOTE,
        CLEAR_ERROR,
        CRASH_ERROR,
        DELETE_NOTE,
        EDIT_NOTE,
        GET_NOTES,
        GLOBAL_RESET,
        MODAL_RESET,
        NOTE_ERROR,
        SET_FETCHING,
        SET_FILTERS,
        SET_LOADING,
        SET_SEARCH,
        SET_SORTING,
        VIEW_NOTE
    } from "../actions/noteTypes"


const initialState = {
    notes: null,
    selectedNote: null,
    loading: false,
    fetching: false,
    notFound: {state: false, text: ""},
    crashError: {state: false, text: ""},
    fetchError: false,
    search: "",
    sortParams: {field:"updatedAt",order:"desc"},
    filterParams: {color:"",tags:[]}
}

export const noteReducer = (state = initialState, action) => {
    switch(action.type){
        case ADD_NOTE:
            if (!state.notes) return state
            if (state.notes.map(note => note._id).includes(action.payload._id)) return state
            let added_notes = [action.payload,...state.notes]
            added_notes = sortNotes(added_notes,state.sortParams)
            return {
                ...state,
                notes: added_notes
            }
        case EDIT_NOTE:
            if (!state.notes) return state
            let updated_notes = [...state.notes]
            if (state.notes.map(note => note._id).includes(action.payload._id)){
                updated_notes = state.notes.map((note)=>{
                    if (note._id === action.payload._id) return action.payload
                    else return note
                })
            }
            else{
                updated_notes.push(action.payload)
            }
            updated_notes = sortNotes(
                updated_notes,
                state.sortParams
            )
            return {
                ...state,
                notes: updated_notes
            }
        case DELETE_NOTE:
            if (!state.notes) return state
            let notes = state.notes.filter(note => note._id !== action.payload)
            return {
                ...state,
                notes: notes
            }
        case VIEW_NOTE:
            return {
                ...state,
                selectedNote: action.payload
            }
        case GET_NOTES:
            return {
                ...state,
                notes: action.payload
            }
        case NOTE_ERROR:
            let { error, operation, note_id }  = action.payload
            if (error.status === 404 && error.data === "NOTE_NOT_FOUND"){
                let message = `The note you're trying to ${operation} is no longer available — it may have been deleted or the link is outdated. Head back to your notes board`
                return {
                    ...state,
                    notFound: {state: true, text: message },
                    notes: (state.notes || []).filter(note => note._id !== note_id)
                }
            }
            else{
                let message = `Our server hit an unexpected issue while attempting to ${operation} a note. Don't worry — your data is safe. Please try again or refresh the page`
                return {
                    ...state,
                    crashError: {state: true, text: message}
                }
            }
        case CLEAR_ERROR:
            return {
                ...state,
                crashError: {state: false, text: ""}
            }
        case CRASH_ERROR:
            return {
                ...state,
                fetchError: action.payload
            }
        case SET_LOADING:
            if (state.crashError.state && action.payload){
                return {
                    ...state,
                    crashError:{state:false,text:"",loading:action.payload}
                }
            }
            return {
                ...state,
                loading: action.payload
            }
        case SET_FETCHING:
            if (state.fetchError && action.payload){
                return {
                    ...state,
                    fetchError: false,
                    fetching: action.payload
                }
            }
            return {
                ...state,
                fetching: action.payload
            }
        case SET_SEARCH:
            return {...state, search: action.payload}
        case SET_FILTERS:
            return {...state, filterParams: action.payload}
        case SET_SORTING:
            return {...state, sortParams: action.payload}
        case MODAL_RESET:
            return {
                ...state,
                loading:false,
                crashError: false,
                notFound: false,
                selectedNote: null
            }
        case GLOBAL_RESET:
            return {
                ...state,
                search: "",
                sortParams: {field:"updatedAt",order:"desc"},
                filterParams: {color:"",tags:[]},
                loading: false,
                fetching: false,
                crashError: false,
                notFound: false,
                selectedNote: null,
                notes: null
            }
        default:
            return state
    }
}